<template>
  <div>
    <div class="form-row mt-3 mr-5" style="align-items: center">
      <div class="col-sm-12">
        <div v-if="this.active != 0">
          <el-tooltip
              placement="top"
              :effect="themeMode.darkMode == true ? 'light' : 'dark'"
              :content="$t('back_to_job_management')">
            <button
                type="button"
                class="btn btn-sm btn-primary el-button--default"
                v-if="this.active < 8"
                @click="previous"
                style="float: right"
            >
              <span>Previous</span>
            </button>
          </el-tooltip>
        </div>
      </div>
    </div>
    <el-form v-if="active === 0">
      <customer-index  @customerCompany="setCustomerCompany" :sectionTitle="sectionTitle"  @customerCompanyId="setCustomerCompanyId" @createJob="createJob" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 1">
      <job-index @jobId="setId" @customerCompanyId="setCustomerCompanyId" :sectionTitle="jobSectionTitle" @createJob="createJob" :customerCompanyId="customerCompanyId" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 2">
      <job-create :refresh="refresh" :customerCompanyId="customerCompanyId" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 3">
      <job-edit :refresh="refresh" :id="job_id" :customerCompanyId="customerCompanyId" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 4">
      <job-management :id="job_id" :sectionTitle="sectionTitle" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 5">
      <job-bid-view :id="job_id" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 6">
      <my-profile :id="customerCompany.company_admin.id"  :remove="false"/>
    </el-form>
    <el-form v-if="active === 7">
      <mydocument-index :customerCompany="customerCompany" :active="active"/>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "CustomerManagementNavigator",
  data() {
    return {
      active: 0,
      id: 0,
      job_id: 0,
      sectionTitle: "Contract Management",
      jobSectionTitle: "Contracts",
      customerCompanyId: 0,
      customerCompany: {},
    };
  },
  methods: {
    createJob(id) {
      this.active = id;
    },
    setCustomerCompanyId(id,activeId){
      //getting
      this.active = activeId;
      this.customerCompanyId = id;
    },
    setCustomerCompany(company, activeId){
      //getting selected company from child component
      this.customerCompany = company;
      this.active = activeId;
    },
    setId(id,activeId) {
      this.active = activeId;
      this.job_id = id;
    },
    refresh() {
      this.active = 1;
    },
    previous() {
      // if (this.active-- < 4) this.active = this.active--;
      this.active = 0;
    },
  },
  computed: {
    themeMode() {
      return this.$store.state.theme;
    },
  },
//   mounted() {
//     let id = ;
//     this.form_id = id
//     alert(this.form_id);
//   },
};
</script>
